<div fxLayout="column" fxLayoutAlign="center center" class="min-width-w">
  <mat-form-field class="mat-form-field" [formGroup]="Form">
    <input matInput type="number" [placeholder]="Title" [ngClass]="Disable ? 'field-input-disabled' : 'field-input'"
      formControlName="Field" [@blinkError]="blinkAnimErr ? 'red' : 'noraml'" (input)="onTextChange()"
      autocomplete="off" [disabled]="Disable" [matTooltip]="FormError">
  </mat-form-field>
  <div fxLayout="column">
    <div fxLayout="row" fxLayoutAlign="center center">
      <div *ngIf="RealValue != undefined && !Disable" class="aro-label-under-input"
        [matTooltip]="'FIELDS.CURRENT_VALUE' | translate">
        {{(units == 1 ? RealValue : transVal(RealValue)) | number :
        '1.0-'+MaxNumsAfterDot}}
      </div>
      <div [ngClass]="Disable ? 'aro-label-under-input-clickable-disabled' : 'aro-label-under-input-clickable'"
        (click)="changeUnitsClick()">{{unitsText}}</div>
    </div>
  </div>
</div>